import { useQuery } from 'react-query'
import request from '../../request'
import { useDealership } from '../../../store/zustand/dealershipStore'

export default function useGetServiceEmailAddress() {
  const dealership = useDealership()
  return useQuery(
    ['dealership', dealership?.id, 'service-email'],
    () =>
      request<{ email: string }>({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/utils/google_spreadsheet/service-user`,
        method: 'GET',
      }),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchInterval: false,
      refetchIntervalInBackground: false,
    },
  )
}
